<template>
    <div id="talk-publish">
        <van-nav-bar
            left-text="取消"
            right-text="发布"
            @click-left="$router.go(-1)"
            @click-right="onPublish"
        >
        </van-nav-bar>

        <van-cell-group id="content" :border= false>
            <van-field v-model="form.content" type="textarea" :autosize="{ maxHeight: 250, minHeight: 80 }" placeholder="说说分享心得吧..." />
        </van-cell-group>

        <div id="headline">
            <img :src="form.link.thumbnail | thumbnail(120,120)" >
            <span class="name">{{name}}</span>
        </div>

    </div>
</template>

<script>
    import { NavBar, CellGroup, Field, Toast } from 'vant';
    import Vue from 'vue'
    Vue.use(NavBar).use(CellGroup).use(Field).use(Toast);


    export default {
        data() {
            return {
                form: {
                    content: '',
                    type: 2,
                    link: {
                        url: '',
                        thumbnail: '',
                        description: ''
                    }
                },
                name: ''
            }
        },

        activated() {
            // console.log(this.$route.params);
            let host = window.location.host
            this.form.link.url = `https://${host}/#/article/detail/${this.$route.params.id}`;
            this.form.link.thumbnail = this.$route.params.thumbnail;
            this.form.link.description = this.$route.params.description;
            this.name = this.$route.params.name
        },
        
        methods: {
            onPublish() {        
                if (this.form.content.length > 250) {
                    Toast('心情不能超过250字哦~');
                    return;
                }
        
                this.$http.post('/api/talk/create', this.form).then(() => {
                    Toast('发布成功~');
                    this.form.content = '';
                    //兼容小程序得web-view
                    if(window.__wxjs_environment === 'miniprogram') {
                        this.$router.replace('/wxapp');
                        return
                    }
                    this.$router.replace('/community/circle/all');
                });
            },
        },
    }
</script>

<style scoped lang="less">
 

    #talk-publish {
        background-color: #fff;
        /deep/ .van-nav-bar {
            border-bottom: 1px solid #eee;
        }
        /deep/ .van-nav-bar__left .van-nav-bar__text {
            color: black;
            font-size: 16px;
        }
        /deep/ .van-nav-bar__right .van-nav-bar__text {
            color: #e9aea8;
            font-size: 16px;
        }
        #content /deep/ [class*=van-hairline]::after {
            content: none;
        }
        #headline{
            margin: 0 3%;
            background-color: #EEEEEE;
            position: relative;
            height: 75px;
            img{
                width: 75px;
                height: 75px;
            }
            .name{
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                font-weight:500;
                color:rgba(34,34,34,1);
                font-size: 16px;
                margin-left: 24px;
            }
        }
    }
</style>